export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresstyp"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontotyp"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Währung"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse erstellen"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto erstellen"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neue Adresse erstellen"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Konto erstellen"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen eingeben"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Währung auswählen"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erstellen"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Typ auswählen"])}
}